import { render, staticRenderFns } from "./SystemBaseMenu.vue?vue&type=template&id=2f6b15d3&scoped=true"
import script from "./SystemBaseMenu.vue?vue&type=script&lang=js"
export * from "./SystemBaseMenu.vue?vue&type=script&lang=js"
import style0 from "./SystemBaseMenu.vue?vue&type=style&index=0&id=2f6b15d3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b15d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6b15d3')) {
      api.createRecord('2f6b15d3', component.options)
    } else {
      api.reload('2f6b15d3', component.options)
    }
    module.hot.accept("./SystemBaseMenu.vue?vue&type=template&id=2f6b15d3&scoped=true", function () {
      api.rerender('2f6b15d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/system/components/System/SystemBaseMenu.vue"
export default component.exports